import React from "react";

interface Props {
  id?: string;
  title?: React.ReactNode;
  description?: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  headerClassName?: string;
}

export default function SectionCard({ id, title, description, action, children, className = "", headerClassName = "" }: Props) {
  const hasHeader = title || description || action;
  return (
    <div
      id={id}
      className={`bg-white rounded-card border border-card p-card shadow-card ${className}`}
    >
      {hasHeader && (
        <div className={`flex items-start justify-between gap-4 mb-5 ${headerClassName}`}>
          <div>
            {title && <h3 className="font-semibold text-[15px] text-zinc-800 leading-snug">{title}</h3>}
            {description && <p className="text-sm text-zinc-400 mt-0.5 leading-relaxed">{description}</p>}
          </div>
          {action && <div className="flex-shrink-0">{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
